import type { Optional } from '@festina-life/core'
import { useEffect, useMemo } from 'react'

import { useMetaModelContext } from './metaModelContext'

/**
 * Utility hook to read a metamodel from the MetaModelProvider cache and to also request that the metamodel
 * is lazily fetched from the server if it is not already in the cache.
 */
export const useLazyLayerMetaModel = (layerId: Optional<string>) => {
  const { getLayerMetaModel, requestLayerMetaModel } = useMetaModelContext()

  useEffect(() => {
    requestLayerMetaModel(layerId)
  }, [layerId, requestLayerMetaModel])

  return useMemo(() => getLayerMetaModel(layerId), [getLayerMetaModel, layerId])
}
